import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS, extend } from "@pnp/common";
var Subscriptions = /** @class */ (function (_super) {
    tslib_1.__extends(Subscriptions, _super);
    function Subscriptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subscriptions.prototype.getById = function (id) {
        return new Subscription(this, id);
    };
    /**
     * Create a new Subscription.
     *
     * @param changeType Indicates the type of change in the subscribed resource that will raise a notification. The supported values are: created, updated, deleted.
     * @param notificationUrl The URL of the endpoint that will receive the notifications. This URL must make use of the HTTPS protocol.
     * @param resource Specifies the resource that will be monitored for changes. Do not include the base URL (https://graph.microsoft.com/v1.0/).
     * @param expirationDateTime Specifies the date and time when the webhook subscription expires. The time is in UTC.
     * @param additionalProperties A plain object collection of additional properties you want to set on the new subscription
     *
     */
    Subscriptions.prototype.add = function (changeType, notificationUrl, resource, expirationDateTime, additionalProperties) {
        var _this = this;
        if (additionalProperties === void 0) { additionalProperties = {}; }
        var postBody = extend({
            changeType: changeType,
            expirationDateTime: expirationDateTime,
            notificationUrl: notificationUrl,
            resource: resource,
        }, additionalProperties);
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                data: r,
                subscription: _this.getById(r.id),
            };
        });
    };
    Subscriptions = tslib_1.__decorate([
        defaultPath("subscriptions")
    ], Subscriptions);
    return Subscriptions;
}(GraphQueryableCollection));
export { Subscriptions };
var Subscription = /** @class */ (function (_super) {
    tslib_1.__extends(Subscription, _super);
    function Subscription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes this Subscription
     */
    Subscription.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Update the properties of a Subscription
     *
     * @param properties Set of properties of this Subscription to update
     */
    Subscription.prototype.update = function (properties) {
        return this.patchCore({
            body: jsS(properties),
        });
    };
    return Subscription;
}(GraphQueryableInstance));
export { Subscription };
//# sourceMappingURL=subscriptions.js.map